.sn-cases {
  &__header {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md); /* ✓ Figma: 16px */
    margin-bottom: map-get($spacings, 3xl); /* ✓ Figma: 40px gap to cards */

    .me-text {
      @include above($breakpoint-desktop-md) {
        max-width: 824px; /* ✓ Figma: 824px */
      }
    }
  }

  &__cards {
    display: grid;
    grid-template-columns: 1fr;
    gap: map-get($spacings, 2xl); /* ✓ Figma: 32px */

    @include above($breakpoint-desktop) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__card-body {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, xl); /* ✓ Figma: 24px */
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, 3xl); /* ✓ Figma: 40px */
    background-color: var(--background-color-secondary);
    border-radius: 12px;
    padding: map-get($spacings, 2xl); /* ✓ Figma: 32px */

    &--blue {
      background-color: var(--color-brand-primary-lighter);
    }
  }

  &__card-title {
    font-weight: 700;
    font-size: map-get($font-sizes, 2xl);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    .me-heading {
      margin-bottom: 0;
    }
  }

  &__card-text {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md); /* ✓ Figma: 16px */
    margin: 0;
    padding-left: map-get($spacings, lg);
  }

  &__list-item {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  &__conclusion {
    font-weight: 400;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);
    color: var(--color-text-primary);
    margin: 0;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-heading--5 {
    font-size: map-get($font-sizes, 3xl);
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
